import {SearchItem, SearchResultDto} from "../search/search-table.dto.res";
import {VehicleDto} from "./vehicle.dto";

export class SearchVehicleRes extends SearchResultDto {

  public override readonly items: SearchVehicleItem[] = [];

  constructor(init?: Partial<SearchVehicleRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchVehicleItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchVehicleItem extends VehicleDto implements SearchItem {

  public override readonly id!: string;
  public readonly contactId!: string;
  public readonly codeNumber: string | undefined;

  constructor(init?: Partial<SearchVehicleItem>) {
    super(init);
    Object.assign(this, init);
  }
}
